import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "akis",
  name: "Akış",
  tagline: "Atıcıları konveyöre sür, tahtayı boşalt; altındaki resmi ya temizle ya da bil.",
  inspiredBy: "Pixel Flow",
  secondLayer: "Gizli resmi tahmin et (bilgi)",
  accent: "#2ec4b6",
  status: "lab",
};
